{
  "brands": {
    "n8n": "n8n",
    "langchain": "langchain",
    "langgraph": "langgraph",
    "react": "react",
    "react 19": "react",
    "react native": "react",
    "next.js": "nextdotjs",
    "node.js": "nodedotjs",
    "express": "express",
    "typescript": "typescript",
    "javascript": "javascript",
    "postgresql": "postgresql",
    "prisma": "prisma",
    "mongodb": "mongodb",
    "mongoose": "mongoose",
    "python": "python",
    "python 3.12+": "python",
    "fastapi": "fastapi",
    "docker": "docker",
    "expo": "expo",
    "eas build": "expo",
    "firebase": "firebase",
    "supabase": "supabase",
    "davinci resolve": "davinciresolve",
    "davinci resolve (free)": "davinciresolve",
    "elevenlabs": "elevenlabs",
    "youtube": "youtube",
    "figma": "figma",
    "figma + figma ai": "figma",
    "framer": "framer",
    "v0.dev": "v0",
    "google": "google",
    "google ads": "googleads",
    "meta ads": "meta",
    "meta ads manager": "meta",
    "analytics": "googleanalytics",
    "ga4": "googleanalytics",
    "google search console": "googlesearchconsole",
    "search console": "googlesearchconsole",
    "html": "html5",
    "css": "css",
    "tailwind css": "tailwindcss",
    "git": "git",
    "github": "github",
    "github actions": "githubactions",
    "vercel": "vercel",
    "vitest": "vitest",
    "testing library": "testinglibrary",
    "vite": "vite",
    "zod": "zod",
    "stripe": "stripe",
    "cursor": "cursor",
    "make.com": "make",
    "zapier": "zapier",
    "claude": "claude",
    "anthropic": "anthropic",
    "gemini": "googlegemini",
    "gemini apis": "googlegemini",
    "figma ai": "figma",
    "anthropic sdks": "anthropic",
    "telegram integrations": "telegram",
    "airtable": "airtable",
    "google sheets": "googlesheets",
    "whatsapp": "whatsapp",
    "telegram": "telegram",
    "hugging face": "huggingface",
    "mcp framework": "modelcontextprotocol",
    "hetzner": "hetzner",
    "revenuecat": "revenuecat",
    "perplexity": "perplexity",
    "wordpress": "wordpress",
    "semrush": "semrush",
    "mailchimp": "mailchimp",
    "remove.bg": "removedotbg",
    "google chrome": "googlechrome",
    "gmail": "gmail",
    "google drive": "googledrive",
    "docs": "googledocs",
    "sheets": "googlesheets",
    "slides": "googleslides",
    "crewai": "crewai"
  },
  "social": {
    "github": "github",
    "youtube": "youtube",
    "x": "x"
  }
}
